import { combineReducers } from "redux";
import room from "./room";
import liveChat from "./liveChat";
import me from "./me";
import producers from "./producers";
import peers from "./peers";
import lobbyPeers from "./lobbyPeers";
import consumers from "./consumers";
import peerVolumes from "./peerVolumes";
import notifications from "./notifications";
import chat from "./chat";
import toolarea from "./toolarea";
import files from "./files";
import settings from "./settings";
import user from "./user";
import whiteboard from "./whiteboard";
import dataConsumers from "./dataConsumers";
import theme from "./theme";
import resizeReducer from "./resize";
import survey from "./survey";
import breakoutReducer from "./breakout";

export default combineReducers({
  room,
  liveChat,
  me,
  producers,
  peers,
  lobbyPeers,
  consumers,
  dataConsumers,
  peerVolumes,
  notifications,
  chat,
  toolarea,
  files,
  settings,
  user,
  whiteboard,
  theme,
  resizeReducer,
  breakoutReducer,
  survey
});
